import uniq from 'lodash/uniq';

import { SombraScopes, SombraStandardScopes } from '@main/sombra-types';
import { invertObjectList } from '@main/utils';

import type { PrivacyCenterQueriesAndMutationsWithAuth } from '.';

const SOMBRA_SCOPES_TO_ROUTES_MINUS_SMART: {
  [name in SombraStandardScopes]: PrivacyCenterQueriesAndMutationsWithAuth[];
} = {
  [SombraStandardScopes.DSRAutomation]: [
    'requestHistory',
    'downloadFilesCountsOnly',
    'downloadFiles',
    'makeDataSubjectRequest',
    'makeDataSubjectRequests',
    'revokeRequest',
    'sombraDataSubjectLogin',
    'dataSubjectDownloadCEK',
    'verifyRequestToken',
    'dataCollectionsRequestFileCount',
  ],
  [SombraStandardScopes.PreferenceManagement]: [
    'requestHistory',
    'dataSubjectConsentPreferences',
    'sombraDataSubjectLogin',
    'generateParentPrivacyCenterLoginToken',
    'dataSubjectUpdateConsentPreferences',
  ],
};

const SOMBRA_SCOPES_TO_PRIVACY_CENTER_ROUTES: {
  [name in SombraScopes]: PrivacyCenterQueriesAndMutationsWithAuth[];
} = {
  ...SOMBRA_SCOPES_TO_ROUTES_MINUS_SMART,
  [SombraScopes.FullAdmin]: uniq(
    Object.values(SOMBRA_SCOPES_TO_ROUTES_MINUS_SMART).flat(),
  ),
};

/**
 * A mapping of backend routes to sets of scopes,
 * where any one of the listed scopes grants access to the route.
 */
export const PRIVACY_CENTER_ROUTE_TO_SOMBRA_SCOPES = invertObjectList(
  SOMBRA_SCOPES_TO_PRIVACY_CENTER_ROUTES,
);

/**
 * Get the allowed Sombra scopes for a given Privacy center endpoint.
 *
 * @param endpoint - The endpoint to check
 * @returns The list of allowed Sombra scopes for the given endpoint
 */
export const getSombraAllowedScopes = (endpoint: string): SombraScopes[] =>
  PRIVACY_CENTER_ROUTE_TO_SOMBRA_SCOPES[
    endpoint as keyof typeof PRIVACY_CENTER_ROUTE_TO_SOMBRA_SCOPES
  ] || [];
